import { ICoordinate } from '@autopylot-internal/tiles-client';
import { State } from '@meraki-internal/state';
import { IAsyncSmartStorageProvider, StorageProvider } from '../support/StorageProvider';
import { Logger } from '../support/debug/Logger';
import coordinatesFormatter from 'formatcoords';
import { TrackingService } from '../support/tracking/TrackingService';

type ILatLngFormatPreference = 'decimal' | 'degrees';

interface ILatLngFormatPreferences {
    preference: ILatLngFormatPreference;
}

export class LatLngFormatPreferenceProvider extends State<Record<string, never>> {
    private storage: IAsyncSmartStorageProvider<ILatLngFormatPreferences>;

    static inject = () => [StorageProvider, TrackingService, Logger];
    constructor(storageProvider: StorageProvider, private tracker: TrackingService, private logger: Logger){
        super({});

        this.storage = storageProvider.getAsyncJSONProvider<ILatLngFormatPreferences>('LatLngFormatPreferenceProvider');

        this.storage.get()
            .then(value => {
                if (value?.preference){
                    this.preference = value.preference;
                }
            })
            .catch((err: any) => {
                this.logger.error(`LatLngFormatPreferenceProvider: Failed to init from storage. Falling back to decimal. ${err.toString()}`);
            });
    }

    preference: ILatLngFormatPreference = 'decimal';

    toggle = ({ trackingFrom }: {trackingFrom: string}) => {
        this.preference = this.preference === 'decimal' ? 'degrees' : 'decimal';
        this.setState({ });
        this.storage.set({
            preference: this.preference
        }).catch(err => {
            this.logger.error(`LatLngFormatPreferenceProvider: Failed to save to storage. ${err.toString()}`);
        });
        this.tracker.track(
            'Lat Lng Format Toggled',
            () => ({
                to: this.preference,
                from: trackingFrom
            })
        );
    };

    getFormattedLatLng = (location?: ICoordinate) => {
        if (!location){
            return '';
        }
        if (this.preference === 'decimal'){
            return coordinatesFormatter(location.lat, location.lng).format('f', { latLonSeparator: ', ', decimalPlaces: 5 });
        }
        return coordinatesFormatter(location.lat, location.lng).format('FFf', { latLonSeparator: ', ', decimalPlaces: 0 });
    };

}
